module.exports = __webpack_public_path__ + "img/warning-1.8c92473a.svg";